import { tv } from 'tailwind-variants'

export const mediaCardInfoVariants = tv({
  slots: {
    container: 'flex flex-col',
    image: 'max-h-[350px] w-full rounded-t-mili object-cover hover:cursor-pointer',
    video: 'max-h-[350px] w-full rounded-t-mili object-contain'
  },
  variants: {
    source: {
      CLIENT: {
        image: 'rounded-br-mili',
        video: 'rounded-br-mili'
      },
      PRODUCT: {
        image: 'rounded-bl-mili',
        video: 'rounded-bl-mili'
      }
    },
    isReply: {
      true: {
        image: 'rounded-t-none rounded-br-none',
        video: 'rounded-t-none rounded-br-none'
      }
    }
  }
})
